var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkOrder = function SvgWorkOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    "data-name": "Work Orders",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.574 18.517H4.127v-8.062H3.001V6.847h15.7v3.608h-1.127v8.061zm-12.77-8.062v7.384h12.097v-7.384zM3.677 7.524v2.254h14.346V7.524zm9.764 6.6H8.634v-2.142h4.807v2.141zm4.589-8.611H4.13v-.677h13.9v.676zM17.022 3.68h-11.8v-.676h11.8v.675z",
    "data-name": "Path 11611"
  })));
};
export default SvgWorkOrder;